export const WETHAddress = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";
export const PancakeSwapRouterAddress = "0x10ED43C718714eb63d5aA57B78B54704E256024E";
export const PancakeSwapFactoryAddress = "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73"
export const UsdtAddress = "0x55d398326f99059ff775485246999027b3197955";
export const PreSaleAddress = "0x3C3614A61300a125e0f55BCdAC90E8EdcAfdC601";
export const TokenAddress = "0x0592c81e7aF7c7b7F4Bf8F43C43A5b5A9914EC5a"
export const PairAddress = "0x530DB479A7645E628aDbe08055a3F276e8351d2D"